module.exports = __webpack_public_path__ + "img/pay-value1.462a2c46.png";